module.exports = __webpack_public_path__ + "dxicons.91732a2beb42a3a3c0a9.ttf";


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/devextreme/dist/css/icons/dxicons.ttf
// module id = ../../../../devextreme/dist/css/icons/dxicons.ttf
// module chunks = 1